import React from 'react';
import styled from 'styled-components';
import { Row, Cell } from './StyledTable';
import { isUndefined, notUndefined } from '../../../lib/typeCheck';
import { DateTime } from 'luxon';
import { ReportSelect } from './selectors/ReportSelect';
import { Icon } from '@iconify/react';
import documentPdf from '@iconify/icons-carbon/document-pdf';

const getRecipientsShortString = (recipients) => {
  
  if (isUndefined(recipients) || recipients.length === 0) return '';
  
  // Create a string of all first names
  let firstNames = recipients
    .map(recipient => notUndefined(recipient.first_name)? recipient.first_name : '')
    .filter(str => str.length > 0)
    .join(', ');
  
  // Trim to limit
  const limit = 20;
  return firstNames.length > limit? firstNames.slice(0, limit) + '...' : firstNames;
}

const statusColourLookup = [
  '#5b63fc',
  '#fc5b5b',
  '#ade6bb'
]

const statusTextLookup = [
  'Pending',
  'Failed',
  'Completed'
];

const ReportStatus = styled.div<{ colour: string; }>`
  width: 16px;
  height: 16px;
  border-radius: 8px;
  margin: 0 auto;
  background: ${props => props.colour};
`;

export const ReportRow = ({ report }: { report: any; }) => {
  console.log(report)
  
  return (
    <Row key={report.id}>
      <Cell>{report.resolvedTemplate.format ==='pdf'? <Icon icon={documentPdf} width={30}/> : null}</Cell>
      <Cell><ReportSelect report={report}/></Cell>
      <Cell>{report.resolvedMenuNode.label}</Cell>
      <Cell centered={true}>-</Cell>
      <Cell centered={true}>{getRecipientsShortString(report.resolvedRecipients)}</Cell>
      <Cell><ReportStatus colour={statusColourLookup[report.status]}/></Cell>
      <Cell>Actions</Cell>
    </Row>
  )
}